import * as React from "react";
import { SVGProps } from "react";

const SPEISimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={62}
    height={22}
    viewBox="0 0 62 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(-22, -22)" fill="currentColor" fillRule="evenodd">
      <path d="M35.6,28.49c1.6-.08,3.12-.2,4.7-.27-.45-3.33-2.06-5.09-6.92-5.09s-6.85,2.45-7.12,4.71c-.31,2.54,1.6,4.16,4.66,5.05,2.64.77,4.85,1.31,4.92,2.61.07,1.39-1.52,2.18-2.31,2.18-1.41,0-2.94-1.56-3.13-2.99-1.53.12-3.13.13-4.66.25,0,3.89,3.16,5.94,7.35,5.94,3.91,0,7.74-1.64,7.74-5.84,0-5.1-5.52-5.1-9.13-6.35-1.26-.7-.6-2.22.58-2.36,2.4-.29,2.81,1.07,3.32,2.17h0ZM50.63,23.54c3.13,0,5.34,1.72,5.34,5.22,0,3.2-2.2,5.25-5.4,5.25h-4v6.13q0,.42-.37.42h-4.17q-.52,0-.52-.39v-15.9q0-.73.73-.73h8.39ZM46.98,30.77c-.3,0-.4-.12-.4-.3v-3.3c0-.24.2-.38.38-.38h1.75c1.51.22,2.06,1.04,2.06,2.1,0,1.52-1.36,1.87-2.54,1.87h-1.25,0Z" />
      <path d="M57.11,24.01c0-.21.15-.38.32-.38h13.29c.29-.01.33.11.33.22v3.04c.01.14-.1.21-.21.21h-8.42c-.18,0-.23.18-.23.38v2.05c0,.22.16.42.42.42h7.45l.17.17v2.85c-.09.12-.17.24-.26.37h-7.5c-.17,0-.28.11-.28.28v2.73c0,.15.18.32.39.32h8.3c.11,0,.17.1.17.17v3.32c0,.08-.09.16-.16.16h-13.64c-.07,0-.14-.07-.14-.14v-16.17h0Z" />
      <path d="M78.27,33.04v7.27h-4.73c-.07,0-.14-.07-.14-.14v-6.5c0-.17.12-.27.21-.27h1.36c.14,0,.17.12.17.22v3.04c0,.38.32.22.49,0,.88-1.21,1.76-2.41,2.64-3.62h0Z" />
      <path d="M73.19,24.01c0-.21.15-.38.32-.38h4.34c.3,0,.41.18.41.33v6.21l-2.66-3.72c-.06-.08-.19-.08-.19.09v2.68c0,.15-.07.43-.29.43h-1.73c-.09,0-.21-.21-.21-.34v-5.31h0Z" />
    </g>
  </svg>
);

export default SPEISimple;
